import { useContext, useState } from "react";
import { patchUserPassword } from "../../../../services/httpService/userRequest";
import { updatePasswordValidator } from "../../../../validators/UserValidator";
import { GlobalContext } from "../../../contexts/globalContext";
import InputText from "../../atoms/InputText/InputText";
import Modal from "../../atoms/Modal/Modal";

const ModalUserPassword = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState({
    password: "",
    newPassword: "",
    passwordConfirmation: "",
  });

  const generateErrorMessage = (error) => {
    let message;
    switch (error.message) {
      case "invalid password":
        message = "Password lama tidak cocok";
        break;
      default:
        message = error.message;
        break;
    }
    return message;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleClose = () => {
    setState({
      password: "",
      newPassword: "",
      passwordConfirmation: "",
    });
    if (props.handleClose) props.handleClose();
  };

  const handleSubmit = async () => {
    try {
      const { error } = await updatePasswordValidator({
        password: state.password,
        newPassword: state.newPassword,
        passwordConfirmation: state.passwordConfirmation,
      });

      if (error) throw new Error(error.details[0].message);
      dispatch("isLoading", true);

      await patchUserPassword({
        _id: sharedState.user._id,
        password: state.password,
        newPassword: state.newPassword,
      });

      handleClose();
      dispatch("isLoading", false);
    } catch (error) {
      let message = generateErrorMessage(error);
      dispatch("alert", {
        type: "warning",
        message: message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };

  return (
    <Modal
      show={props.show}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    >
      <div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Password Lama</div>
          <InputText
            type="password"
            autoComplete="new-password"
            className="col-span-12 sm:col-span-9"
            name="password"
            value={state.password}
            onChange={handleChange}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Password Baru</div>
          <InputText
            type="password"
            autoComplete="new-password"
            className="col-span-12 sm:col-span-9"
            name="newPassword"
            value={state.newPassword}
            onChange={handleChange}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Konfirmasi Password</div>
          <InputText
            type="password"
            autoComplete="new-password"
            className="col-span-12 sm:col-span-9"
            name="passwordConfirmation"
            value={state.passwordConfirmation}
            onChange={handleChange}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalUserPassword;
